import { createFileRoute } from '@tanstack/react-router'
import { SearchPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/search')({
  head: () => staticRouteHead('search', 'en'),
  component: SearchPage,
})
